import React, { useEffect, useState } from "react";

import estilo from "./styles/Menu.module.css";
import { Link, NavLink } from "react-router-dom";

function Menu() {
  const [activo, setActivo] = useState(false);

  function menu() {
    if (window.innerWidth <= 768) {
      setActivo(!activo);
    }
  }

  useEffect(() => {
    function handleScroll() {
      const menu = document.querySelector("#menu");
      const divSobreNosotros = document.querySelector("#inicio");
      const { top } = divSobreNosotros.getBoundingClientRect();
      if (top <= -50) {
        menu.classList.add(estilo.bg);
        // console.log(true);
      } else {
        menu.classList.remove(estilo.bg);
        // console.log(false);
      }
    }

    window.addEventListener("scroll", handleScroll);
  }, []);
  return (
    <div className={estilo.menu} id="menu">
      <Link to={"/"}>
        <h1>Bryan's WebFolio</h1>
      </Link>

      <ul
        className={
          activo ? `${estilo.lista} ${estilo.lista_activa}` : estilo.lista
        }
      >
        <NavLink
          to={"/"}
          className={({ isActive }) => (isActive ? estilo.activo_page : "")}
          onClick={menu}
        >
          <li>Inicio</li>
        </NavLink>
        <NavLink
          to={"/sobre-mi"}
          className={({ isActive }) => (isActive ? estilo.activo_page : "")}
          onClick={menu}
        >
          <li>Sobre Mi</li>
        </NavLink>
        <NavLink
          to={"/portafolio"}
          className={({ isActive }) => (isActive ? estilo.activo_page : "")}
          onClick={menu}
        >
          <li>Portafolio</li>
        </NavLink>
        <NavLink
          to={"/contacto"}
          className={({ isActive }) => (isActive ? estilo.activo_page : "")}
          onClick={menu}
        >
          <li>Contacto</li>
        </NavLink>

        <div className={estilo.cerrar} onClick={menu}>
          <div className={estilo.x_linea}></div>
          <div className={estilo.x_linea}></div>
        </div>
      </ul>

      <div className={estilo.menu_icon} onClick={menu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}

export default Menu;
